import Vue from 'vue'

import map from 'lodash/map'
import find from 'lodash/find'
import cloneDeep from 'lodash/cloneDeep'
import { mapState, mapGetters } from 'vuex'

export default Vue.extend({
  name: 'PostIdMixin',
  data() {
    return {
      post: { title: '' } as any,
    }
  },
  computed: {
    ...mapState({ brand: (state: any) => state.brand.brand }),
    ...mapGetters({
      activePrivateProcedures: 'setting/activePrivateProcedures',
      settingsProcedures: 'procedures/getSettingsProcedures',
      userAuxRole: 'users/getAuxRole',
      userRole: 'users/getRole',
    }),
  },
  methods: {
    async getPostData() {
      let data: any
      const postId = this.$route.params.postId
      const { module, submodule } = this.$route.params

      const getDocument = async (docId: any) => {
        return await this.$fire.firestore
          .collection(`modules/${module}/${submodule}`)
          .doc(docId)
          .get()
      }

      const queryPost = await this.$fire.firestore
        .collection(`modules/${module}/${submodule}`)
        .where('configPath.slug', '==', postId)
        .get()

      if (queryPost.empty) {
        data = await getDocument(postId)
      } else {
        data = queryPost.docs[0]
      }

      if (!data || !data.exists) {
        this.$router.push({
          path: '/digital-services',
        })
      } else {
        // Revisamos si es un trámite privado
        const privateProcedure = data.data().privateProcedure
        if (
          privateProcedure &&
          (!this.activePrivateProcedures ||
            (['', 'user'].includes(this.userRole) &&
              this.userAuxRole === 'citizen'))
        ) {
          this.$router.push({ path: '/digital-services' })
        }

        // Obtenemos la configuración del operador
        let operatorConfig: any
        let questions: any
        let sections: any
        // Si viene de un modulo que no es ventanilla hacemos el query
        if (module !== 'ventanillaDigital' && submodule !== 'procedures') {
          operatorConfig = await getDocument('settings')
          questions = operatorConfig.data().questions
          sections = operatorConfig.data().sections
        } else {
          // Si viene del modulo ventanilla utilizamos el store para ahorrarnos el query
          operatorConfig = cloneDeep(this.settingsProcedures)
          questions = operatorConfig.questions
          sections = operatorConfig.sections
        }
        this.post = {
          ...data.data(),
          postId,
          id: data.id,
          answersOperatorConfig: map(questions, (question: any) => ({
            id: question.id,
            section: question.section,
            showOnFile: question.showOnFile,
            positionOnFile: question.positionOnFile,
            icon: question.icon,
            label: question.label,
            kind: question.kind,
            sectionTitle: find(sections, { id: question.section }).name,
            sectionRichText: find(sections, { id: question.section })
              .richTextLabel,
            indexInFile: question.indexInFile || null,
          })),
        }
      }
    },
  },
})
